module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAPpJREFUSEvt1LENwjAQBdCzomQGChpGYAxLTMAIISJmAGbAWCiMwAYkHSlYIBIlmwTZ6CSKCFHYPmMK4ibNRS/+9xVW17WBHxyGMOecxbTRHOEoiY9RR4kZEXLUeZ5Psiw7aq23Sqmb7ZeTYETTNL0AwLTv+3lVVfevw0PUGMOVUldb1DtqKuoFh0Cd4VCoE1wUxSxJkjMWyWen7/u3brUQYgUABwA4SSmXLkX6NGsN48tlWe4ZY2sAkFLKDQV3ghESQuzwQcWd4VC4FxwC94apOAke4lpr/G02toUjw6+2L7qua9q2fUSFbbHhXJAbj7BNAn8ctU08oWeeQaU0ZpkEnmoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/turn-page-left.png
// module id = GoZN
// module chunks = 0